import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {
  deleteUser as deleteUserApi
} from "../../../../../api/clients/users";
import { Link } from "react-router-dom";
import { ACL, USER_DELETE_STATUSES } from "../../../../../config/constants";
import { NOTIFICATION_CLIENT_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function DeleteClient(props) {
  const [ showDeleteModal, setShowDeleteModal ] = useState( false );

  if (! ACL.CLIENT.USERS.DELETE.hasAccess()) {
    return null;
  }

  const { index, actionCallback, user, showIcon } = props;

  const deleteUser = () => {
    deleteUserApi( {
      userId: user.id,
      notificationId: NOTIFICATION_CLIENT_ACTIONS
    } ).then( (response) => {
      setShowDeleteModal( false );

      if (response && response.status === 200) {
        actionCallback();
      }
    } );
  };

  const shouldDisplay = (user) => {
    return ( ! user || USER_DELETE_STATUSES.includes( user.status ) ) ? false : true;
  }

  if (! shouldDisplay( user )) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`delete-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowDeleteModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.delete_user"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`delete-icon-${index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.delete_user"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`delete-icon-` + props.index}
            onClick={() => setShowDeleteModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faTrash}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`delete-icon-${props.index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.delete_user"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showDeleteModal}
        closeModal={() => setShowDeleteModal( false )}
        confirmationYes={deleteUser}
      />
    </Fragment>
  );
}

export { DeleteClient };
